import RichTextEditor from 'react-rte'

/**
 * Extrai o texto puro de um valor rich-text
 */
export const getRichTextPlainText = (value: string): string => {
  const richTextValue = RichTextEditor.createValueFromString(value ?? '', 'html')
  const textBlocks = JSON.parse(richTextValue.toString('raw')).blocks
  return textBlocks.map((block: { text?: string }) => block.text?.toString() ?? '').join('')
}

/**
 * Verifica se um valor de rich-text não possui nenhum conteúdo de texto real.
 */
export const isRichTextEmpty = (value: string): boolean => !/\S/.test(getRichTextPlainText(value))
